import { Component, OnInit } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AcompanhamentoGerenciarPage } from "../acompanhamento-gerenciar/acompanhamento-gerenciar.page";
import { AcompanhamentoProvider } from "src/app/services/acompanhamento/acompanhamento";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { addDays, format, isBefore, isEqual, subDays } from "date-fns";
import { CommonModule } from "@angular/common";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { ToastController } from "@ionic/angular/standalone";

@Component({
  selector: "app-acompanhamento-historico",
  templateUrl: "./acompanhamento-historico.page.html",
  styleUrls: ["./acompanhamento-historico.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ReactiveFormsModule,
    ProverDatepickerComponent,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class AcompanhamentoHistoricoPage implements OnInit {
  historicoList: any = [];
  validations_form: FormGroup;
  dataInicio = format(new Date(), "yyyy-MM-dd");
  loaded = false;
  dataFim = format(new Date(), "yyyy-MM-dd");
  filtroResponsavel: string;
  list: any = [
    { id: 2, nome: this.translate.instant("Todos")},
    { id: 0, nome: this.translate.instant("Equipe") },
    { id: 1, nome: this.translate.instant("Meus") },
  ];
  filtro: any = {
    inicializado: false,
    filtroResponsavel: 2,
    dataInicio: format(subDays(new Date(), 20), "yyyy-MM-dd"),
    dataFim: format(new Date(), "yyyy-MM-dd"),
  };
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    private translate: TranslateService,
    public formBuilder: FormBuilder,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController
  ) {}

  ngOnInit() {
    this.filtroResponsavel = this.filtro.filtroResponsavel;
    this.validations_form = this.formBuilder.group({
      filtroResponsavel: new FormControl(
        this.filtro.filtroResponsavel,
        Validators.nullValidator
      ),
      dataInicio: new FormControl(
        this.filtro.dataInicio,
        Validators.nullValidator
      ),
      dataFim: new FormControl(this.filtro.dataFim, Validators.nullValidator),
    });

    this.dataInicio = this.filtro.dataInicio;
    this.dataFim = this.filtro.dataFim;

    this.buscar();
  }

  buscar() {
    this.acompanhamentoProvider.getHistorico(this.filtro).subscribe({
      next: (data) => {
        this.historicoList = data.historico;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro ao buscar o Historico:", err);
        this.loaded = true;
      },
    });
  }

  async detalhes(acompanhamento: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoGerenciarPage,
      componentProps: {
        acompanhamento: acompanhamento,
        isResponsavel: false,
        historico: true,
      },
    });
    modalPage.present();

    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.buscar();
    }
  }

  getFontColor(acompanhamento: { cor: any }) {
    return acompanhamento.cor;
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  getIcon(acompanhamento: { icone: string | string[] }) {
    if (acompanhamento.icone.includes(" fa-")) {
      return acompanhamento.icone;
    } else {
      return "fas fa-" + acompanhamento.icone;
    }
  }

  setFormValue(field: string, form: any) {
    this.validations_form.controls[field].setValue(form);
  }

  async onSubmit(form: any) {
    const result =
      isBefore(new Date(form.dataInicio), new Date(form.dataFim)) ||
      isEqual(new Date(form.dataInicio), new Date(form.dataFim));
    
      if (!result) {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("As datas informadas não atendem aos critérios de validação."),
          duration: 3000,
        });
    
        toast.present();
        return;
      }

    this.setFormValue("filtroResponsavel", this.filtro.filtroResponsavel);
    form.dataInicio = this.dataInicio;
    form.dataFim = this.dataFim;
    this.modalCtrl.dismiss(form);
    this.filtro = form;
    this.buscar();
  }

  onDateTime(date = "") {
    this.filtro.dataInicio = this.dataInicio;
    this.filtro.dataFim = this.dataFim;
  }
}
